// extracted by mini-css-extract-plugin
export default {"title":"AdvantagesList_title__EixM6","list":"AdvantagesList_list__yCjZb","item":"AdvantagesList_item__EEWrP","offered":"AdvantagesList_offered__ajmi8"};